import React, { useState, useEffect } from 'react';
import {
    TextField,
    Box,
    Button,
    Badge,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
} from '@mui/material';
import FilterListIcon from '@mui/icons-material/FilterList';
import {
    COMERCIAL_OPTIONS,
    OPERACIONES_OPTIONS,
    normalizeAgentValue,
} from './cofidisAgentConfig';

const getFilterState = (filters = {}) => ({
    q: filters.q || '',
    mobile: filters.mobile || '',
    operacionesAgent: filters.operacionesAgent
        ? normalizeAgentValue('operacionesAgent', filters.operacionesAgent)
        : '',
    comercialAgent: filters.comercialAgent
        ? normalizeAgentValue('comercialAgent', filters.comercialAgent)
        : '',
});

export const CofidisCaseFilter = ({ filters, setFilters }) => {
    const [open, setOpen] = useState(false);
    const [localFilters, setLocalFilters] = useState(getFilterState(filters));

    useEffect(() => {
        setLocalFilters(getFilterState(filters));
    }, [filters]);

    const handleClick = () => {
        setLocalFilters(getFilterState(filters));
        setOpen(true);
    };

    const handleClose = () => {
        setLocalFilters(getFilterState(filters));
        setOpen(false);
    };

    const handleFilterChange = (field) => (event) => {
        setLocalFilters((prev) => ({
            ...prev,
            [field]: event.target.value,
        }));
    };

    const handleApply = () => {
        setFilters({
            q: localFilters.q.trim(),
            mobile: localFilters.mobile.trim(),
            operacionesAgent: localFilters.operacionesAgent
                ? normalizeAgentValue('operacionesAgent', localFilters.operacionesAgent)
                : '',
            comercialAgent: localFilters.comercialAgent
                ? normalizeAgentValue('comercialAgent', localFilters.comercialAgent)
                : '',
        });
        setOpen(false);
    };

    const hasActiveFilters = () => (
        (filters.q && filters.q.trim() !== '') ||
        (filters.mobile && filters.mobile.trim() !== '') ||
        (filters.operacionesAgent && filters.operacionesAgent.trim() !== '') ||
        (filters.comercialAgent && filters.comercialAgent.trim() !== '')
    );

    const countActiveFilters = () => {
        let count = 0;

        if (filters.q && filters.q.trim() !== '') count++;
        if (filters.mobile && filters.mobile.trim() !== '') count++;
        if (filters.operacionesAgent && filters.operacionesAgent.trim() !== '') count++;
        if (filters.comercialAgent && filters.comercialAgent.trim() !== '') count++;

        return count;
    };

    const clearFilters = () => {
        const emptyFilters = {
            q: '',
            mobile: '',
            operacionesAgent: '',
            comercialAgent: '',
        };

        setLocalFilters(emptyFilters);
        setFilters(emptyFilters);
        setOpen(false);
    };

    return (
        <>
            <Badge
                badgeContent={hasActiveFilters() ? countActiveFilters() : 0}
                color="primary"
                sx={{ ml: 1 }}
            >
                <Button
                    id="confidis-filter-button"
                    onClick={handleClick}
                    startIcon={<FilterListIcon />}
                    variant="outlined"
                    size="small"
                >
                    Filter
                </Button>
            </Badge>
            <Dialog
                open={open}
                onClose={handleClose}
                maxWidth="sm"
                fullWidth
                PaperProps={{
                    sx: {
                        borderRadius: '8px',
                        border: '1px solid rgba(0, 0, 0, 0.12)',
                    },
                }}
            >
                <DialogTitle>Filter Cases</DialogTitle>
                <DialogContent>
                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3, pt: 1 }}>
                        <TextField
                            label="Search"
                            value={localFilters.q}
                            onChange={handleFilterChange('q')}
                            size="small"
                            placeholder="Search cases..."
                            InputLabelProps={{ shrink: true }}
                            fullWidth
                            sx={{
                                '& .MuiInputLabel-root': {
                                    fontSize: '0.875rem',
                                },
                                '& .MuiOutlinedInput-root': {
                                    fontSize: '0.875rem',
                                },
                            }}
                        />
                        <TextField
                            label="Mobile Number"
                            value={localFilters.mobile}
                            onChange={handleFilterChange('mobile')}
                            size="small"
                            placeholder="Enter Mobile Number"
                            InputLabelProps={{ shrink: true }}
                            fullWidth
                            sx={{
                                '& .MuiInputLabel-root': {
                                    fontSize: '0.875rem',
                                },
                                '& .MuiOutlinedInput-root': {
                                    fontSize: '0.875rem',
                                },
                            }}
                        />
                        <TextField
                            label="Operaciones"
                            value={localFilters.operacionesAgent}
                            onChange={handleFilterChange('operacionesAgent')}
                            size="small"
                            fullWidth
                            select
                            InputLabelProps={{ shrink: true }}
                            SelectProps={{
                                native: true,
                            }}
                            sx={{
                                '& .MuiInputLabel-root': {
                                    fontSize: '0.875rem',
                                },
                                '& .MuiOutlinedInput-root': {
                                    fontSize: '0.875rem',
                                },
                            }}
                        >
                            <option value="">Todas las opciones</option>
                            {OPERACIONES_OPTIONS.map((option) => (
                                <option key={option} value={option}>{option}</option>
                            ))}
                        </TextField>
                        <TextField
                            label="Comercial"
                            value={localFilters.comercialAgent}
                            onChange={handleFilterChange('comercialAgent')}
                            size="small"
                            fullWidth
                            select
                            InputLabelProps={{ shrink: true }}
                            SelectProps={{
                                native: true,
                            }}
                            sx={{
                                '& .MuiInputLabel-root': {
                                    fontSize: '0.875rem',
                                },
                                '& .MuiOutlinedInput-root': {
                                    fontSize: '0.875rem',
                                },
                            }}
                        >
                            <option value="">Todas las opciones</option>
                            {COMERCIAL_OPTIONS.map((option) => (
                                <option key={option} value={option}>{option}</option>
                            ))}
                        </TextField>
                    </Box>
                </DialogContent>
                <DialogActions>
                    <Button onClick={clearFilters} size="small">
                        Clear
                    </Button>
                    <Button onClick={handleApply} variant="contained" size="small">
                        Apply
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
};
